const RouteNames = {
    Home: "/:lang",
    About: "/:lang/about",
    Expertise: "/:lang/expertise",
    Career: "/:lang/career",
    Contact: "/:lang/contact",
    Sitemap: "/:lang/sitemap"
}

export default RouteNames;